import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApi } from '../../lib/api';
import RoleDetail from './RoleDetail';

export default function MyRole() {
  const { appId } = useParams();
  const api = useApi();
  const [roleId, setRoleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.getMyDashboard(appId)
      .then(data => {
        if (data.roles && data.roles.length > 0) {
          setRoleId(data.roles[0].id);
        } else {
          setError('No role assigned to you yet.');
        }
        setLoading(false);
      })
      .catch(err => {
        setError(err.response?.data?.error || 'Failed to load your role info');
        setLoading(false);
      });
  }, [appId, api]);

  if (loading) return <p className="muted" style={{ padding: 24 }}>Finding your role...</p>;
  if (error) return <div className="banner banner-error" style={{ margin: 24 }}>{error}</div>;
  if (!roleId) return <div className="banner banner-info" style={{ margin: 24 }}>No role assigned.</div>;

  return <RoleDetail roleId={roleId} />;
}
